<template>
	<div class="mt-pannel">
		<div 
			class="mt-pannel__header" 
			v-bind="headerCustomAttr"
			v-bind:class="{borderBottom:headerBorderBottom}"
			v-show="hasHeaderSlot">
			<slot name="header"></slot>
		</div>
		<div class="mt-pannel__body" :style="{height:bodyHeight}">
			<slot></slot>
			<div class="mt-pannel--vertical" v-show="hasVerticalSlot">
				<div class="mt-pannel--vertical__middle">
					<div class="mt-pannel--vertical__inner">
						<slot name="vertical"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>


export default {
	name: 'mt-pannel',
	props: {
		headerCustomAttr: {
			type: Object,
			default: function () {
        return {}
      }
		},
		headerBorderBottom: {
			type: Boolean,
			default: false
		},
		bodyHeight: {
			type: [Number, String],
			default: 'auto'
		}
	},
	components: {

	},

	data () {
		return {
			hasVerticalSlot: false,
			hasHeaderSlot: false
		}
	},
	created () {
		
	},
	mounted () {
		let that = this
		setTimeout(function(){
			that.hasVerticalSlot = !!that.$slots['vertical']
			that.hasHeaderSlot = !!that.$slots['header']
		})
	},
	beforeUpdate () {
		let that = this
		setTimeout(function(){
			that.hasVerticalSlot = !!that.$slots['vertical']
			that.hasHeaderSlot = !!that.$slots['header']
		})
	},
	computed: {

	},
	methods: {
		
	},
	
	
}
</script>

<style src="./Pannel.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Pannel.vue?1b35820a